export class CatUnidadesFracaoFactory {
  constructor(instance) {
    this.instance = instance;
  }

  getUnidadesFracao(filter) {
    return this.instance.get('/v1/cat-unidades-fracao', {
      params: filter || null,
    });
  }

  inserirUnidadeFracao(data) {
    const payload = {
      unidade: data.unidade,
      quantidade: data.quantidade,
      unidadeSaida: data.unidadeSaida || 'kg',
    };

    return this.instance.post('/v1/cat-unidades-fracao', payload);
  }

  editarUnidadeFracao(id, data) {
    return this.instance.put(`/v1/cat-unidades-fracao/${id}`, data);
  }

  deletarUnidadeFracao(id) {
    return this.instance.delete(`/v1/cat-unidades-fracao/${id}`);
  }
}

export default (...params) => new CatUnidadesFracaoFactory(...params);
